function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { useMemo, useRef } from "react";
import ReactReplJS from "./ReactReplJS";
export var useReactReplJS = function useReactReplJS() {
  var submitCodeRef = useRef();
  return useMemo(function () {
    return {
      ReactRepl: function ReactRepl(props) {
        return /*#__PURE__*/React.createElement(ReactReplJS, _extends({}, props, {
          submitCodeRef: submitCodeRef
        }));
      },
      submitCode: function submitCode(code) {
        submitCodeRef.current(code);
      }
    };
  }, []);
};
export default useReactReplJS;